var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMapPin = function SvgIconMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 6.227c0 2.01-1.345 4.165-2.756 5.859A24.386 24.386 0 0 1 8 14.728a24.38 24.38 0 0 1-2.577-2.642c-1.412-1.694-2.757-3.85-2.757-5.859 0-1.137.581-2.318 1.554-3.222A5.58 5.58 0 0 1 8 1.5a5.58 5.58 0 0 1 3.78 1.505c.972.904 1.553 2.085 1.553 3.222Z",
    stroke: "currentColor",
    strokeWidth: 0.667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.666 7.5 2 1.666 3-4",
    stroke: "currentColor",
    strokeWidth: 0.667,
    strokeLinecap: "round"
  })));
};
export default SvgIconMapPin;